import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ChecklistBody from "./ChecklistBody";
import useRampChecklist from "./useRampChecklist";

/**
 * 移动端整页：本站航班列表点进来的过站检查单录入页（含返回入口）。
 */
export default function ChecklistPage() {
    const { legId } = useParams();
    const navigate = useNavigate();
    const state = useRampChecklist(legId, { onCompleted: () => navigate("/ramp-checklist") });

    return (
        <div style={{ maxWidth: 720, margin: "0 auto", padding: 12 }}>
            <Space style={{ marginBottom: 8 }}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/ramp-checklist")}>
                    返回本站航班
                </Button>
            </Space>
            <ChecklistBody state={state} showFlightInfo showTitle mobile />
        </div>
    );
}
